<template>
<!-- <div>
  <form action="submitMulti" ref="formContent">
    <div>select file</div>
    <input type="file" />
    <input type="button" value="提交" @click="subMit" />
  </form>
</div> -->

<div class="image-select">
    <span>选择图片</span>    
    <picture-input 
      ref="pictureInput"
      width="600" 
      height="600" 
      margin="16" 
      accept="image/jpeg,image/png, image/jpg" 
      size="10" 
      button-class="btn"
      :custom-strings="{
        upload: '<h1>Bummer!</h1>',
        drag: 'Drag a 😺 GIF or GTFO'
      }"
      @change="onChange">
    </picture-input>

    <!-- <span>选择视频</span>    
    <picture-input 
      ref="pictureInput"
      width="600" 
      height="600" 
      margin="16" 
      accept="video/mp4" 
      size="10" 
      button-class="btn"
      :custom-strings="{
        upload: '<h1>Bummer!</h1>',
        drag: 'Drag a 😺 GIF or GTFO'
      }"
      @change="onChange">
    </picture-input>

    <span>选择文件</span>    
    <picture-input 
      ref="pictureInput"
      width="600" 
      height="600" 
      margin="16" 
      accept="application/pdf" 
      size="10" 
      button-class="btn"
      :custom-strings="{
        upload: '<h1>Bummer!</h1>',
        drag: 'Drag a 😺 PDF'
      }"
      @change="onChange">
    </picture-input> -->
  </div>
</template>

<script>

import PictureInput from 'vue-picture-input'
import utils from '@/utils/domain'
import Axios from 'axios'
const axios = Axios.create({})

export default {
components: {
PictureInput
},
data() {
    return {
      image: undefined
    };
},
computed: {

},
watch: {

},
methods: {
  onChange (image) {
      console.log('New picture selected!')
      if (image) {
        console.log('Picture loaded.')
        this.image = image
        console.log('Picture loaded.', image)
        var dataURL = image;
        var blob = this.dataURItoBlob(dataURL);
        this.upload(blob); //执行上传接口
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
  },
  dataURItoBlob (dataURI) {
      // base64 解码
      let byteString = window.atob(dataURI.split(',')[1]);
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      let T = mimeString.split('/')[1];
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {type: mimeString});
  },
  upload(blob){
　　　let formData = new FormData();
      let filename = Date.now() + '.jpg'
　　　formData.append('file', blob, filename);

      axios.defaults.withCredentials = true
      axios({
        url: utils.getDomain() + '/resource/upload',
        method: 'POST',
        headers: {
          'x-api-token': this.$store.state.loginToken,
          'Content-Type':'multipart/form-data'
        },
        data: formData
      })
      .then(({ data }) => {
        console.log("resp_data", data)
      })
      .catch(( error ) => {
        console.log("error_occur", error)
      })
  },
subMit() {
    // var formData = new FormData(this.$refs.formContent);
    console.log("select_file")
  }
},
created() {

},
mounted() {

},
}
</script>
<style lang='scss' scoped>

</style>